import { Object3D } from 'three';
import { Box3 } from 'three';
import { Vector3 } from 'three';

import { Time } from 'ohzi-core';
import { CameraManager } from 'ohzi-core';

import { ViewManager } from 'ohzi-core'
import { Sections } from '../views/Sections';

export default class FlyToState {

	constructor(camera_controller, state_handler) {
		this.camera_controller = camera_controller;
		this.state_handler = state_handler;
		this.move_vec3 = new Vector3();
		this.home_view = ViewManager.get_view_by_name(Sections.HOME)
	}

	set_up(initial_sub_scene, end_sub_scene) {
		if (end_sub_scene.icon && !end_sub_scene.icon.no_label) {
			this.home_view.update_card(end_sub_scene.icon.labelObject);
		}
		this.initial_sub_scene = initial_sub_scene;
		this.end_sub_scene = end_sub_scene;

		this.initial_tilt = this.camera_controller.current_tilt;
		this.initial_orientation = this.camera_controller.current_orientation;
		this.initial_camera_position = CameraManager.current.position.clone();
		this.initial_camera_target = this.camera_controller.reference_position.clone();


      	this.final_tilt =  end_sub_scene.tilt;
      	this.final_orientation =  end_sub_scene.orientation;
      	this.final_camera_position = end_sub_scene.camera_position.clone();
      	this.final_camera_target = end_sub_scene.camera_target.clone();

		this.lerp = 0;

	}

	go_to() {
		this.state_handler.go_to_stationary(this.end_sub_scene);
	};

	fade_out () {

	};

	fade_in () {

	};

	animate() {

	};

	update(camera_controller) {
		this.lerp = this.lerp + Time.delta_time * 0.8;
		this.lerp = Math.min(Math.max(this.lerp, 0.0), 1.0);
			
		const lerper = this.lerp//Math.pow(this.lerp, 2);
		const lerper2 = Math.pow(this.lerp, 2);

		this.initial_sub_scene.fade_out(lerper);
		this.end_sub_scene.fade_in(lerper);


      	this.camera_controller.lerp_rotation(
      		this.initial_tilt,
      		this.final_tilt,
      		this.initial_orientation,
      		this.final_orientation,
      		lerper2
      	)

      	this.camera_controller.reference_position.lerpVectors(this.initial_camera_target, this.final_camera_target, lerper);
		this.move_vec3.lerpVectors(this.initial_camera_position, this.final_camera_position, lerper);

      	this.camera_controller.set_position_by_zooming(this.move_vec3);
		
		if(this.lerp === 1) {
			this.go_to(this.end_sub_scene);
		}
	};
}